function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
document.addEventListener("DOMContentLoaded",() =>{
  setTimeout(() =>{
    //const wpIframe = document.querySelector('.WizybotShopifyWidget__iframe__outter__close')
    //wpIframe.setAttribute('style', 'z-index: 1 !important;right: 0px; bottom: 75px; width: 70px;height: 70px;');
  }, 1000)
})


if(location.pathname == "/collections/all") location.pathname = "/collections/todos-productos";

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  if (summary.nextElementSibling?.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    // document.body.style.overflowY = 'hidden';
    document.body.classList.add('overflow-hidden-desktop')
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    // document.body.style.overflowY = 'auto';
    document.body.classList.remove('overflow-hidden-desktop')
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]')?.addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if(modal.classList.contains('ctn-quick-add')){
        this.quickAdd(modal)
      }else{
        if (modal) modal.show(button);
      }
    });
  }

  quickAdd(modal) {
    const modalOpened = document.querySelector('.show-quick-modal');
    const btnClose = modal.querySelector('.ctn-bottom  .icon-close')
    btnClose.addEventListener('click', () =>{
      modal.style.display = 'none';
      document.body.classList.remove('overflow-hidden-tablet');
      document.body.classList.remove('overflow-hidden-desktop')
    })
    if (modalOpened) {
      modalOpened.classList.remove('show-quick-modal');
      modalOpened.style.display = 'none';
    }
    
    window.onclick = null;
    window.onclick = function(event) {
      const elementToClose = (event.target.closest('.card-product') && !event.target.closest('.ctn-quick-add') && !event.target.closest('.ctn-icon-cart-quick-add')) || 
                             (event.target.closest('#product-grid') && !event.target.closest('.ctn-quick-add') && !event.target.closest('.ctn-icon-cart-quick-add'));
      if (event.target == modal || elementToClose) {
        modal.style.display = 'none';
        document.body.classList.remove('overflow-hidden-tablet');
        // document.body.style.overflowY = 'auto';
        document.body.classList.remove('overflow-hidden-desktop')
      }
    };

    modal.style.display = 'block';
    modal.classList.add('show-quick-modal');
    document.body.classList.add('overflow-hidden-tablet');

    const buttonsVariant = modal.querySelectorAll('.ctn-bottom .variants .item-variant');
    const messageResponse = modal.querySelector('#message-add-cart');
    const buttonAdd = modal.querySelector('.btn-add-cart');
    const buttonsOpenSizeGuide = modal.querySelector('.btn-open-guide-quick')
    buttonsOpenSizeGuide?.addEventListener('click', () =>{
      const product = buttonsOpenSizeGuide.getAttribute('data-target');
      const objProduct = JSON.parse(product)
      buttonsOpenSizeGuide.closest('.ctn-quick-add').style['z-index'] = 7
      // document.body.style.overflowY = 'hidden';
      document.body.classList.add('overflow-hidden-desktop')
      this.guideSize(objProduct, modal)
    })
    buttonsVariant.forEach(variant => {
      let newVariant = variant.cloneNode(true);
      variant.replaceWith(newVariant);
    });

    let buttonAddClone = buttonAdd.cloneNode(true);
    buttonAdd.replaceWith(buttonAddClone);

    const newButtonsVariant = modal.querySelectorAll('.ctn-bottom .variants .item-variant');
    const newButtonAdd = modal.querySelector('.btn-add-cart');

    newButtonAdd.setAttribute("disabled", "true");
    newButtonAdd.classList.add("disabled");

    let data = [];
    let dataVariant = {}

    // Asignar nuevos event listeners a los variants
    newButtonsVariant.forEach((variant) => {
      variant.classList.remove('active');
      data = [];
      dataVariant = {}
      variant.addEventListener('click', (e) => {
        const elementVariant = e.target;
        newButtonsVariant.forEach(v => v.classList.remove('active'));

        const variantId = elementVariant.getAttribute('data-variant');
        const variantPrice = elementVariant.getAttribute('data-price');
        const variantVendor = elementVariant.getAttribute('data-vendor');
        const variantComparePrice = elementVariant.getAttribute('data-compare-price');
        const variantTitle = elementVariant.getAttribute('data-title');
        const variantOption = elementVariant.getAttribute('data-variant-options');
        const variantImage = elementVariant.getAttribute('data-image');
        const quantityVariant = elementVariant.getAttribute('data-variant-quantity');
        dataVariant = {
          variantId,
          variantPrice,
          variantVendor,
          variantComparePrice,
          variantTitle,
          variantOption,
          variantImage,
          quantityVariant
        }
        elementVariant.classList.add('active');
        newButtonAdd.removeAttribute("disabled");
        newButtonAdd.classList.remove("disabled");
        data = [
          {
            id: variantId,
            quantity: 1
          }
        ];
      });
    });

    // Asignar el event listener al botón de agregar al carrito
    newButtonAdd.addEventListener('click', (e) => {
      const cart = document.querySelector('cart-notification')
      const formData = new FormData();// Tamaño seleccionado
      formData.append('form_type', 'product'); 
      formData.append('utf8', '✓'); 
      formData.append('id', data[0].id);
      formData.append('sections', 'cart-notification-product,cart-notification-button,cart-icon-bubble');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
      .then(response => response.json())
      .then(data => {      
        if (data.status > 400) {
          messageResponse.textContent = data.description;
          return;
        }
        const bubble = document.getElementById('cart-icon-bubble');
        messageResponse.textContent = 'Agregado al carrito';
        if (bubble) bubble.innerHTML = data.sections['cart-icon-bubble'];
        bubble.querySelector('div').style.height = '45px';
        modal.style.display = 'none';
        cart.renderContents(data);
        localStorage.setItem('product-buy', JSON.stringify(dataVariant))
      })
      .catch(error => {
        console.log(error);
        messageResponse.textContent = 'Error al agregar al carrito';
      })
      .finally(() => {
        newButtonsVariant.forEach(v => v.classList.remove('active'));
        newButtonAdd.setAttribute("disabled", "true");
        newButtonAdd.classList.add("disabled");
        setTimeout(() => {
          messageResponse.textContent = '';
        }, 3000);
      });
    });
  }


  guideSize(product, modal){
    const guideProduct = document.querySelector(`.guide-product-main .mod-guia-de-tallas-${product.id}`)
    const buttonClose = guideProduct.querySelector('.cerrar-pop')
    guideProduct.style.display = 'block';


    buttonClose.addEventListener('click', () =>{
      guideProduct.style.display = 'none';
      buttonClose.closest('.ctn-quick-add').style['z-index'] = 3
    })
    // guia
    // function calculateSize(row, ring = ''){
    //   let sizeIn, sizeCm;
    //   if (ring) {
    //     const sizeMm = row.split("-").map(size => parseFloat(size));
    //     sizeIn = sizeMm.map(size => (size / 25.4).toPrecision(3));
    //     sizeCm = $("<span>").addClass("size-cm").text(row.replace(/mm/g, ''));
    //   } else {
    //     sizeIn = row.split("-").map(size => (size / 2.54).toPrecision(3));
    //     sizeCm = $("<span>").addClass("size-cm").text(row.replace(/"/g, ''));
    //   }
    //   const data = sizeIn.length > 1 ? `${sizeIn[0]}-${sizeIn[1]}` : `${sizeIn[0]}`;
    //   let sizeInP = $("<span>").addClass("size-in").text(data.replace(/"/g, ''));
  
    //   return [sizeCm, sizeInP];
    // }
      // if (tipo === "CALZADO") {
      //   document.querySelector(".guide-product-main .med-largo").outerHTML = "<th class='size-calc med-largo'>Largo (cm)</th>";
      // }   
      // if (tipo === "RING") {
      //   const tabCm = document.querySelector('.tabs-sizes .tab-size');
      //   if (tabCm) {
      //     tabCm.textContent = "MM";
      //   }
      //   document.querySelector(".guide-product-main .med-largo").outerHTML = "<th class='size-calc med-largo'>Largo (mm)</th>";
      // }
      let tipo = "";
      let marcaProducto = product.vendor;
      let tipoProducto = product.type;
      let tablaMostrar = "";
      let genero = "";
      let marca = "";
      let position = "GENERAL";
      let unisex = false;

      if (product.tags.includes("SUPERIOR")) {
        position = "SUPERIOR";
      } else if (product.tags.includes("INFERIOR") || product.tags.includes("CALZADO")) {
        position = "INFERIOR";
      } else {
        position = "GENERAL";
      }
      if(product.tags.includes("MUJER") && product.tags.includes("HOMBRE")){
        unisex = true
      }
      if (product.tags.includes("MUJER")) {
        genero = "MUJER";
        if (product.tags.includes("BRASIERES")) {
          tipo = "INTERIOR";
          tablaMostrar = modal.querySelector(".guide-product-main .tallas-mujer-brasieres");
        } else if (product.tags.includes("ROPA")) {
          tipo = "ROPA";
          tablaMostrar = modal.querySelector(".guide-product-main .tallas-mujer-ropa");
        } else if (product.tags.includes("CALZADO")) {
          tipo = "CALZADO";
          tablaMostrar = modal.querySelector(".guide-product-main .tallas-mujer-calzado");
        } else if (product.tags.includes("ANILLOS") || product.tags.includes("ACCESORIOS")) {
          tipo = "ACCESORIOS";
          tablaMostrar = modal.querySelector(".guide-product-main .tallas-mujer-ropa");
        }
      } else if (product.tags.includes("NINA")) {
        genero = "NINA";
        if (product.tags.includes("BRASIERES")) {
          tipo = "INTERIOR";
          tablaMostrar = modal.querySelector(".guide-product-main .tallas-nina-brasieres");
        } else if (product.tags.includes("ROPA")) {
          tipo = "ROPA";
          tablaMostrar = modal.querySelector(".guide-product-main .tallas-nina-ropa");
        } else if (product.tags.includes("CALZADO")) {
          tipo = "CALZADO";
          tablaMostrar = modal.querySelector(".guide-product-main .tallas-nina-calzado");
        } else if (product.tags.includes("ACCESORIOS")) {
          tipo = "ACCESORIOS";
          tablaMostrar = modal.querySelector(".guide-product-main .tallas-nina-ropa");
        }
      } else if (product.tags.includes("HOMBRE")) {
        genero = "HOMBRE";
        if (product.tags.includes("ROPA")) {
          tipo = "ROPA";
          tablaMostrar = modal.querySelector(".guide-product-main .tallas-hombre-ropa");
        } else if (product.tags.includes("CALZADO")) {
          tipo = "CALZADO";
          tablaMostrar = modal.querySelector(".guide-product-main .tallas-hombre-calzado");
        } else if (product.tags.includes("ACCESORIOS")) {
          tipo = "ACCESORIOS";
          tablaMostrar = modal.querySelector(".guide-product-main .tallas-hombre-ropa");
        }
      } else if (product.tags.includes("NINO")) {
        genero = "NINO";
        if (product.tags.includes("ROPA")) {
          tipo = "ROPA";
          tablaMostrar = modal.querySelector(".guide-product-main .tallas-hombre-ropa");
        } else if (product.tags.includes("CALZADO")) {
          tipo = "CALZADO";
          tablaMostrar = modal.querySelector(".guide-product-main .tallas-hombre-calzado");
        } else if (product.tags.includes("ACCESORIOS")) {
          tipo = "ACCESORIOS";
          tablaMostrar = modal.querySelector(".guide-product-main .tallas-hombre-ropa");
        }
      }
      if (tablaMostrar && tablaMostrar.innerHTML !== "") {
        tablaMostrar.innerHTML = "";
      }
      
      function getTallas() {
        const data = localStorage.getItem("sizeGuide");
        let tallasPorPais = modal.querySelector('.guide-product-main .sizes-country');
        var allRows = data.split(/\r?\n|\r/);
        
        for (var singleRow = 0; singleRow < allRows.length; singleRow++) {
          var rowCells = allRows[singleRow].split(';');
          
          if (marcaProducto.toLocaleUpperCase() == rowCells[0].trim().toLocaleUpperCase()) {
            marca = marcaProducto.toLocaleUpperCase();
          }
          
          if (rowCells[0] && rowCells[0].trim().toLocaleUpperCase() == marca) {
            if (rowCells[1] && (rowCells[1].trim() == genero || unisex)) {
              if (rowCells[2] && rowCells[2].trim() == tipo) {
                if (rowCells[3] && rowCells[3].trim() == position) {
                  if ((rowCells[4] === "" && !["enterizos", "enterizos & sets", "blazers", "camisas", "vestidos"].includes(tipoProducto.toLowerCase())) || rowCells[4].trim().toLowerCase() == tipoProducto.toLowerCase()) {
                    let row = document.createElement("tr");
                    row.classList.add("row-size-guia-de-tallas");   
                    row.classList.add(`${rowCells[1].trim()}`)       
                    if (rowCells[5]) {
                      let th = document.createElement("th");
                      th.classList.add("estandar");
                      th.textContent = rowCells[5];
                      row.appendChild(th);
                      // modal.querySelector(".guide-product-main thead th.estandar").style.display = "block";
                    } else {
                      modal.querySelector(".guide-product-main thead th.estandar").style.display = "none";
                    }
                    
                    if (rowCells[12] && rowCells[12] !== '-') {
                      let th = document.createElement("th");
                      th.classList.add("med-colombia");
                      th.classList.add("countries");
                      th.textContent = rowCells[12].replace(/"/g, '').replace(/\*/g, '-');
                      row.appendChild(th);
                    }
                    
                    if (rowCells[13] && rowCells[13] !== '-') {
                      let th = document.createElement("th");
                      th.classList.add("med-usa");
                      th.classList.add("countries");
                      th.textContent = rowCells[13].replace(/"/g, '').replace(/\*/g, '-');
                      row.appendChild(th);
                    }
                    
                    if (rowCells[14] && rowCells[14] !== '-') {
                      let th = document.createElement("th");
                      th.classList.add("med-europa");
                      th.classList.add("countries");
                      th.textContent = rowCells[14].replace(/"/g, '').replace(/\*/g, '-');
                      row.appendChild(th);
                    }
                    
                    if (rowCells[15] && rowCells[15] !== '-') {
                      let th = document.createElement("th");
                      th.classList.add("med-bra");
                      th.classList.add("countries");
                      th.textContent = rowCells[15].replace(/"/g, '').replace(/\*/g, '-');
                      row.appendChild(th);
                    }
                    
                    if (!rowCells[12] && !rowCells[13] && !rowCells[14] && !rowCells[15]) {
                      modal.querySelector("th.select-pais").style.display = "none";
                      modal.querySelector(".cont_tabla_tallas .select").style.display = "none";
                    }
                    
                    // Additional cells handling
                    const createSizeCell = (size, className) => {
                      if (size) {
                        // const [sizeCm, sizeInP] = calculateSize(size);
                        let th = document.createElement("th");
                        th.classList.add(className);
                        th.textContent = size;
                        row.appendChild(th);
                        // modal.querySelector(`.guide-product-main thead th.${className}`).style.display = "block";
                      } else {
                        modal.querySelector(`.guide-product-main thead th.${className}`).style.display = "none";
                      }
                    };
      
                    createSizeCell(rowCells[6], "med-cuello");
                    createSizeCell(rowCells[7], "med-pecho");
                    createSizeCell(rowCells[8], "med-cintura");
                    createSizeCell(rowCells[9], "med-espalda");
                    createSizeCell(rowCells[10], "med-cadera");
      
                    if (rowCells[11]) {
                      // const [sizeCm, sizeInP] = calculateSize(rowCells[11], tipoProducto.toLowerCase() === 'anillos' ? "ring" : undefined);
                      let th = document.createElement("th");
                      th.classList.add("med-largo");
                      th.textContent = rowCells[11];
                      row.appendChild(th);
                    } else {
                      modal.querySelector(".guide-product-main thead th.med-largo").style.display = "none";
                    }
                    
                    tablaMostrar.appendChild(row);
      
                    // Handling country-specific logic
                    const handleCountryDisplay = (value, className, spanText) => {
                      if (!tallasPorPais.querySelector(`option[value='${value}']`)) {
                        let option = document.createElement("option");
                        option.value = value;
                        option.selected = true;
                        option.textContent = spanText;
                        tallasPorPais.appendChild(option);
                      }
                      modal.querySelectorAll(".guide-product-main th.countries").forEach(el => el.style.display = "none");
                      modal.querySelectorAll(`.guide-product-main .${className}`).forEach(el => el.style.display = "block");
                      modal.querySelector(".guide-product-main thead th.select-pais span").textContent = spanText;
                    };
      
                    if (rowCells[13]) {
                      handleCountryDisplay("usa", "med-usa", "USA");
                    }
                    if (rowCells[14]) {
                      handleCountryDisplay("europa", "med-europa", "EU");
                    }
                    if (rowCells[15]) {
                      handleCountryDisplay("bra", "med-bra", "BRA");
                    }
                    if (rowCells[12]) {
                      handleCountryDisplay("colombia", "med-colombia", "COL");
                    }
                  }
                }
              }
            }
          }
        }
      
        const selectCountry = modal.querySelector('.guide-product-main .mod-guia-de-tallas-2 .cont_tabla_tallas .select-pais .select');
        const selectOptions = selectCountry.querySelector('select');
      
        if (selectCountry && selectOptions.options.length == 1) {
          selectCountry.style.display = "none";
          modal.querySelector('.guide-product-main .mod-guia-de-tallas-2 .cont_tabla_tallas .select-pais span').style.display = "block";
          modal.querySelector('.guide-product-main .mod-guia-de-tallas-2 .cont_tabla_tallas .select-pais').style.display = "inline";
        } else if (selectOptions.options.length == 0) {
          selectCountry.style.display = "none";
        }

        if(unisex){
          const selectGender = modal.querySelector('.sizes-gender')
          const trGenderNoSelected = modal.querySelectorAll(`tr.row-size-guia-de-tallas:not(.${selectGender.value})`)
          trGenderNoSelected.forEach((element) =>{
            element.classList.add('hidden-row')
          })
          selectGender.addEventListener('change', (e) =>{
            const trGenderSelectAll = modal.querySelectorAll(`tr.row-size-guia-de-tallas`)
            trGenderSelectAll.forEach((element) =>{
              element.classList.add('hidden-row')
            })
          const trGenderSelect = modal.querySelectorAll(`tr.row-size-guia-de-tallas.${e.target.value}`)
            trGenderSelect.forEach((element) =>{
              element.classList.remove('hidden-row')
            })
          });
        }
      } 
      getTallas()
      modal.querySelector(".guide-product-main .sizes-country").addEventListener("change", function() {
        const selectedValue = modal.querySelector(".guide-product-main .sizes-country").value;
      
        if (selectedValue === "usa") {
          modal.querySelectorAll(".guide-product-main .med-colombia").forEach(el => el.style.display = "none");
          modal.querySelectorAll(".guide-product-main .med-europa").forEach(el => el.style.display = "none");
          modal.querySelectorAll(".guide-product-main .med-usa").forEach(el => el.style.display = "block");
          modal.querySelectorAll(".guide-product-main .med-bra").forEach(el => el.style.display = "none");
        } else if (selectedValue === "colombia") {
          modal.querySelectorAll(".guide-product-main .med-colombia").forEach(el => el.style.display = "block");
          modal.querySelectorAll(".guide-product-main .med-europa").forEach(el => el.style.display = "none");
          modal.querySelectorAll(".guide-product-main .med-usa").forEach(el => el.style.display = "none");
          modal.querySelectorAll(".guide-product-main .med-bra").forEach(el => el.style.display = "none");
        } else if (selectedValue === "europa") {
          modal.querySelectorAll(".guide-product-main .med-colombia").forEach(el => el.style.display = "none");
          modal.querySelectorAll(".guide-product-main .med-europa").forEach(el => el.style.display = "block");
          modal.querySelectorAll(".guide-product-main .med-usa").forEach(el => el.style.display = "none");
          modal.querySelectorAll(".guide-product-main .med-bra").forEach(el => el.style.display = "none");
        } else if (selectedValue === "bra") {
          modal.querySelectorAll(".guide-product-main .med-colombia").forEach(el => el.style.display = "none");
          modal.querySelectorAll(".guide-product-main .med-europa").forEach(el => el.style.display = "none");
          modal.querySelectorAll(".guide-product-main .med-usa").forEach(el => el.style.display = "none");
          modal.querySelectorAll(".guide-product-main .med-bra").forEach(el => el.style.display = "block");
        }
      });
      
      modal.querySelector(".guide-product-main .cerrar-pop").addEventListener("click", function() {
        modal.querySelector(".mod-guia-de-tallas-2").style.display = "none";
        // document.body.style.overflowY = "auto";
        document.body.classList.remove('overflow-hidden-desktop')
      });
      
      modal.querySelector(".guide-product-main .mod-guia-de-tallas-2").addEventListener("click", function(e) {
        if (!e.target.closest(".cont-mod-guia-tallas-2")) {
          modal.querySelector(".mod-guia-de-tallas-2").style.display = "none";
          // document.body.style.overflowY = "auto";
          document.body.classList.remove('overflow-hidden-desktop')
          modal.closest('.ctn-quick-add').style['z-index'] = 3
        }
      });
      
      modal.querySelector("#btn-guia-tallas-2").addEventListener("click", function() {
        modal.querySelector(".mod-guia-de-tallas-2").style.display = "block";
        // document.body.style.overflow = "hidden";
        document.body.classList.add('overflow-hidden-desktop')
      });
      
      // $(".btn-open-guide-quick").on("click", function (e) {
      //   console.log("di click")
      //   e.stopPropagation()
      //   e.preventDefault();
      //   getTallas(localStorage.getItem('guiaTallas'))
      //   const tallaClass = $(this).data("target");
      //   $("." + tallaClass).css("display", "block");
      //   document.body.style.overflow = "hidden";
      // });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider) return;
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }
    const segments = document.querySelectorAll('.pagination-segment');
    
    segments.forEach((segment, index) => {
      if (index + 1 === this.currentPage) {
        segment.classList.add('active');
      } else {
        segment.classList.remove('active');
      }
    });

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide?.classList.add(`${animationClassOut}-${direction}`);
    nextSlide?.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide?.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide?.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.updateSelect()
  }
  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, window.variantStrings.soldOut, true);
      this.setUnavailable();
    } else {
      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut, true);
      this.updateMedia();
      this.updateURL(event);
      this.updateVariantInput(event);
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL(event) {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    if(event.target && event.target.classList.contains('select_product') && event.target.classList.contains('select-size')){
      location.reload()
    }
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput(event) {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    // available stores
    // NOTA: '#id-variant' solo existe en la página cuando el producto tiene
    // "recogida en tienda" habilitada (lo renderiza pick-up-store.liquid).
    // Antes, si el producto no tenía esa opción, este elemento no existía y
    // "idVariant.innerText = ..." lanzaba un error sin capturar, deteniendo
    // aquí toda la función — por lo que el resto de este método (que es
    // justamente el que actualiza el input real name="id" enviado al
    // carrito) nunca se ejecutaba, y el carrito terminaba agregando la
    // talla con la que cargó la página en vez de la recién seleccionada.
    const idVariant = document.getElementById('id-variant')
    if (idVariant) idVariant.innerText = this.currentVariant.id
    // options size
    const options = event.target.querySelectorAll('option');
    options.forEach(option => {
      option.innerText = option.innerText.replace("Seleccionado", "")
      if(option.value == this.currentVariant.title){
        option.innerText = option.innerText + "Seleccionado"
      }
    })
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.setAttribute("data-price", this.currentVariant.price);
      input.setAttribute("data-compare-price", this.currentVariant.compare_at_price);
      input.setAttribute("data-variant-options", this.currentVariant.option1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const checkedInput = this.querySelector(':checked');

    if (!checkedInput) {
      return; // 🔥 evita el error si no hay selección
    }

    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => checkedInput.value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const prevChecked = inputWrappers[index - 1].querySelector(':checked');
      if (!prevChecked) return;

      const previousOptionSelected = prevChecked.value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`sku-description`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        
        if (skuSource && skuDestination) {
          skuDestination.textContent = skuSource.textContent;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  updateSelect() {
    const selectElement = this.querySelector('.variant-real-select');
    if (!selectElement) return;

    const options = selectElement.options;
    if (!options) return;

    // if (options.length === 1) {
    //   selectElement.disabled = true;

    //   const wrapper = selectElement.closest('.select');
    //   if (wrapper) {
    //     wrapper.style.pointerEvents = 'none';
    //     const svg = wrapper.querySelector('svg');
    //     if (svg) svg.style.display = 'none';
    //   }
    // }

    // limpiar hidden
    for (let i = 0; i < options.length; i++) {
      options[i].classList.remove('hidden');
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.initSwiper();
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }

  initSwiper() {
    // new Swiper('.mySwiper1Products', {
    //   direction: 'horizontal',
    //   loop: true,
    //   scrollbar: {
    //     el: '.swiper-scrollbar',
    //     hide: true,
    //   }
    // });

    new Swiper('.mySwiperProducts', {
      slidesPerView: "auto",
      loop: true,
      spaceBetween: 5,
      autoplay: {
        delay: 4500,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
    });
  }
}

customElements.define('product-recommendations', ProductRecommendations);